import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import paymentItem from './modules/paymentItem';
import email from './modules/email';
import todo from './modules/todo';
import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';
import responsePermission from './modules/responsePermission';
import unread from './modules/unread';
import fileUpload from './modules/fileUpload';
import submitFormMessage from './modules/submitFormMessage';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
      empCompanyId:0,
      dirty:false,
      isPageBodyLoading: false,
    },
    mutations: {
      changeLang (state, payload) {
        localStorage.setItem('currentLanguage', payload.id);
        localStorage.setItem('currentLanguageName', payload.name);
        localStorage.setItem('currentLanguageIcon', payload.icon);
        localStorage.setItem('currentLangId', payload.langid);
        
        // 从URL中移除lang参数
        const url = new URL(window.location.href);
        url.searchParams.delete('lang');
        
        // 重新加载页面但不包含lang参数
        window.location.href = url.toString();
      },
      setPageBodyLoading (state, isLoading) {
        state.isPageBodyLoading = isLoading;
      }
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload);
      },
      setPageBodyLoading ({ commit }, isLoading) {
        commit('setPageBodyLoading', isLoading);
      }
    },
    modules: {
      alert,
      authentication,
      users,
      layout,
      chat,
      menu,
      paymentItem,
      products,
      email,
      todo,
      firebase_todo,
      jobs,
      courses,
      common,
      responsePermission,
      unread,
      fileUpload,
      submitFormMessage,
    },
});

